import React from "react";
import { useTranslation } from "react-i18next";
import { Review } from "../../../types/modules/review.type"; // <-- path where you put your type
import { Star } from "lucide-react"; // icon for rating stars

interface Props {
  reviews: Review[];
}

const ReviewsTable: React.FC<Props> = ({ reviews }) => {
  const { t } = useTranslation();

  const renderStars = (rating: number) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={16}
            className={i < rating ? "text-Black fill-Black" : "text-gray-300"}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            {/* <th className="p-3 font-normal">{t("orderNo")}</th> */}
            <th className="p-3 font-normal capitalize font">{t("customer")}</th>
            <th className="p-3 font-normal capitalize">{t("feedback")}</th>
            <th className="p-3 font-normal capitalize">{t("rating")}</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {reviews.map((review, index) => (
            <tr
              key={review.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >

              {/* Customer (Image + Name) */}
              <td className="p-3 flex items-center gap-3 min-w-[250px]">
                <div>
                  {
                    !review.isAnonymous &&
                    <img
                    src={review.customer.imageUrl || review.customer.avatar.url}
                    alt={review.customer.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  }
                </div>
                <div className="flex flex-col">
                  <span className="text-Black mb-1 font-black text-[12px]">
                    {review.isAnonymous ? t("anonymous") : review.customer.name}
                  </span>
                </div>
              </td>

              {/* Feedback */}
              <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
                {review.comment}
              </td>

              {/* Rating Stars */}
              <td className="p-3 min-w-[150px]">{renderStars(review.rating)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewsTable;
